import { useContext, useEffect, useState } from "react";
import "./CustomerInvoicesDetail.css";
import { CustomerInvoicesDetailMain } from "./CustomerInvoicesDetailMain";
import { CustomerInvoicesDetailProducts } from "./CustomerInvoicesDetailProducts";
import { CustomerInvoicesDetailServices } from "./CustomerInvoicesDetailServices";
import { CustomerInvoicesDetailAdditional } from "./CustomerInvoicesDetailAdditional";
import { CustomerInvoicesDetailFooter } from "./CustomerInvoicesDetailFooter";
import DocumentDetailViewToolbar from "src/components/Shared/DetailViews/DocumentDetailViewToolbar";
import InvoicesDetailViewHeader from "src/components/Shared/DetailViews/InvoicesDetailViews/InvoicesDetailViewHeader";
import InvoicesDetailViewsRefreshButton from "src/components/Shared/DetailViews/InvoicesDetailViews/InvoicesDetailViewsRefreshButton";
import { PaymentOffset } from "src/components/Shared/Settlements/PaymentOffset";
import { NFTabContainer } from "src/components/Shared/NewForms/NFTabContainer";
import { ICustomerInvoiceModel } from "src/components/Pages/Documents/CustomerInvoices/models/ICustomerInvoiceModel";
import { FormProvider, useForm } from "react-hook-form";
import { NFTabs } from "src/components/Shared/NewForms/NFTabs";
import { NFTab } from "src/components/Shared/NewForms/NFTab";
import { NFDateInput } from "src/components/Shared/NewForms/NFDateInput";
import { ICustomerInvoicesDto } from "../dtos/ICustomerInvoicesDto";
import { useFetchCustomerInvoice } from "../hoooks/fetchDocument";
import DetailViewPostButton from "src/components/Shared/DetailViews/DetailViewPostButton";
import DetailViewCancelButton from "src/components/Shared/DetailViewCancelButton";

interface IProps {
  id?: string;
}

interface TableRow {
  document: string;
  customer: string;
  setOff: string;
  amount: number;
  id: number;
}

export const CustomerInvoiceDetail = ({ id }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<ICustomerInvoiceModel>();
  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("Customer Invoices");

  const [amountDue, setAmountDue] = useState<number>(5000);
  const [firstTableData, setFirstTableData] = useState<TableRow[]>([
    {
      document: "AR/AP transaction 1",
      customer: "Customer 1",
      setOff: "Available (USD) 1",
      amount: 2000,
      id: 1
    },
    {
      document: "AR/AP transaction 2",
      customer: "Customer 2",
      setOff: "Available (USD) 2",
      amount: 3000,
      id: 2
    },
    {
      document: "AR/AP transaction 2",
      customer: "Customer 3",
      setOff: "Available (USD) 3",
      amount: 6000,
      id: 3
    }
  ]);

  const [secondTableData, setSecondTableData] = useState<TableRow[]>([]);

  const handleSetOffClick = (row: TableRow, index: number, fromSecondTable: boolean) => {
    const transferAmount = row.amount;

    if (fromSecondTable) {
      setSecondTableData((prevData) => prevData.filter((_, i) => i !== index));
      const existingRow = firstTableData.find((item) => item.id === row.id);
      if (existingRow) {
        const newData = firstTableData.map((item) => {
          if (item.id === row.id) {
            return {
              ...item,
              amount: item.amount + row.amount
            };
          }
          return item;
        });
        setFirstTableData(newData);
      } else {
        setFirstTableData((prevData) => [...prevData, row]);
      }
      setAmountDue((prevAmountDue) => prevAmountDue + transferAmount);
    } else {
      if (transferAmount > amountDue) {
        const transferRow = {
          ...row,
          amount: amountDue
        };
        setSecondTableData((prevData: any) => [...prevData, transferRow]);
        setFirstTableData((prevData) => prevData.map((item, i) => (i === index ? { ...item, amount: item.amount - amountDue } : item)));
        setAmountDue(0);
      } else {
        setFirstTableData((prevData) => prevData.filter((_, i) => i !== index));
        setSecondTableData((prevData) => [...prevData, row]);
        setAmountDue(amountDue - transferAmount);
      }
    }
  };
  const { isDocumentLoading, documentModel, postDocument, cancelDocument, updateDocument } = useFetchCustomerInvoice({ documentId: id });

  useEffect(() => {
    if (documentModel) {
      reset(documentModel);
    }
  }, [documentModel]);

  useEffect(() => {
    if (formState.isDirty) {
      console.log("formState.isDirty", formState.isDirty);
      updateDocument(getValues());
    }
  }, [formState.isDirty]);

  const handlePost = async () => {
    await postDocument();
  };

  const handleCancel = async () => {
    await cancelDocument();
  };

  // const exportToExcel = () => {
  //   const data = {
  //     ...model
  //   };
  //   const documentInfo = {
  //     title: AppEntities.CustomerInvoices.title,
  //     number: model.documentNumber,
  //     date: model.documentDate
  //   };
  //   saveObjectToExcel(data, documentInfo);
  // };

  // const handleUploadFile = (file: File) => {
  //   importFromExcel(file, (data: any) => {
  //     reset(data);
  //   });
  // };

  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex: any) => {
          setTabIndex(newIndex);
        }}
      >
        <NFTab title={"Main"} />
        <NFTab title={"Products"} />
        <NFTab title={"Services"} />
        <NFTab title={"Payment Offset"} />
        <NFTab title={"Additional"} />
      </NFTabs>
      <div className={"modal-container-height"}>
        <DocumentDetailViewToolbar>
          <DetailViewPostButton onPost={handlePost} />
          <DetailViewCancelButton onCancel={handleCancel} />
          {/*<DetailViewToolbarMoreActions handleUploadFile={handleUploadFile} exportToExcel={exportToExcel}*/}
          {/*                              fileName={fileName} setFileName={setFileName}/>*/}
        </DocumentDetailViewToolbar>
        {/* {tabIndex === 0 || tabIndex === 1 || tabIndex === 2 ? (
          <DocumentDetailViewToolbar>
            <DetailViewPostButton onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))} />
            <DetailViewSaveButton onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))} />
            <DetailViewCancelButton onCancel={cancelHandler} />
            <DetailViewToolbarMoreActions handleUploadFile={handleUploadFile} exportToExcel={exportToExcel} fileName={fileName} setFileName={setFileName} />
          </DocumentDetailViewToolbar>
        ) : (
          <InvoicesDetailViewHeader>
            <InvoicesDetailViewExecuteButton onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))}/>
            <InvoicesDetailViewCancelButton  onCancel={cancelHandler}/>
            <InvoicesDetailViewsRefreshButton />
            <DetailViewToolbarMoreActions handleUploadFile={handleUploadFile} exportToExcel={exportToExcel} fileName={fileName} setFileName={setFileName} />
          </InvoicesDetailViewHeader>
          <InvoicesModalViewHeader
            onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))}
            onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))}
            onClose={closeHandler}
            onCancel={cancelHandler}
            handleSetOffClick={handleSetOffClick}
          />
        )} */}

        <NFTabContainer index={0} currentIndex={tabIndex}>
          <CustomerInvoicesDetailMain />
        </NFTabContainer>

        <NFTabContainer index={1} currentIndex={tabIndex}>
          <CustomerInvoicesDetailProducts />
        </NFTabContainer>

        <NFTabContainer index={3} currentIndex={tabIndex}>
          <PaymentOffset availablePayments={[]} selectedPayments={[]} onDoCreditPayment={() => {}} onApplyChanges={() => {}} onRefreshAvailablePayments={async () => {}} />
          <NFDateInput title="documentData" fieldName="documentData" />
        </NFTabContainer>
        <NFTabContainer index={2} currentIndex={tabIndex}>
          <CustomerInvoicesDetailServices />
        </NFTabContainer>

        <NFTabContainer index={4} currentIndex={tabIndex}>
          <CustomerInvoicesDetailAdditional />
        </NFTabContainer>
      </div>
      <CustomerInvoicesDetailFooter />
    </FormProvider>
  );
};
